import { getFromStorage } from "./localStorage";

export const defaultPrefs = {
  functional: true,
  analytics: false,
  marketing: false,
};

export const allAccepted = {
  functional: true,
  analytics: true,
  marketing: true,
};

export function saveCookiePrefs(prefs) {
  localStorage.setItem("cookie_prefs", JSON.stringify(prefs));
}

export function getCookiePrefs() {
  return getFromStorage("cookie_prefs");
}

export function hasConsent() {
  return !!getCookiePrefs();
}
